export default __webpack_public_path__ + "static/media/clock_icon.75d18e21.svg";